module.exports = __webpack_public_path__ + "img/success-error.fc416696.png";